import { render, staticRenderFns } from "./TouchingSides.vue?vue&type=template&id=45c1a62d&"
import script from "./TouchingSides.vue?vue&type=script&lang=js&"
export * from "./TouchingSides.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports